import {
  DatePickerType,
  DatePickerInput as RawDatePickerInput,
  DatePickerInputProps as RawDatePickerInputProps,
} from '@mantine/dates';
import classNames from 'classnames';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import useCombinedRefs from 'hooks/use-combined-refs';
import { forwardRef, useRef } from 'react';

import styles from './styles.module.css';

import 'dayjs/locale/id';

dayjs.locale('id');
dayjs.extend(customParseFormat);

export interface DatePickerInputProps<Type extends DatePickerType>
  extends Omit<
    RawDatePickerInputProps<Type>,
    | 'inputWrapperOrder'
    | 'format'
    | 'inputFormat'
    | 'labelFormat'
    | 'firstDayOfWeek'
    | 'radius'
    | 'dayClassname'
  > {
  type: Type;
  noMargin?: boolean;
}

const DatePickerInput = forwardRef<
  HTMLInputElement,
  DatePickerInputProps<DatePickerType>
>((props, ref) => {
  const innerRef = useRef<HTMLInputElement | null>(null);
  const combinedRef: any = useCombinedRefs(ref, innerRef);
  const {
    className,
    rightSection,
    type,
    noMargin,
    disabled,
    readOnly,
    valueFormat = 'DD/MM/YYYY',
    ...rest
  } = props;

  const _disabled = disabled || readOnly;

  return (
    <RawDatePickerInput
      ref={combinedRef}
      {...rest}
      type={type}
      inputWrapperOrder={['label', 'input', 'description', 'error']}
      className={classNames(styles.datePicker, className)}
      radius="md"
      firstDayOfWeek={0}
      valueFormat={valueFormat}
      readOnly={_disabled}
    />
  );
});

DatePickerInput.displayName = 'DatePickerInput';

export default DatePickerInput;
